export enum SourceSystemName {
  PLENIGO,
  WEBABO
}
